<app-header-mobile (backClicked)="advancedSearch()"></app-header-mobile>

<div>
    <div class="border-bottom border-primary-subtle px-3 py-1 container mt-2">
        <div class="d-flex">
            <h6 class="modal-title">Schedule Information</h6>
            <div *ngIf="!isShowSchedule" (click)="isShowSchedule=!isShowSchedule">
                <svg enable-background="new 0 0 32 32" height="16px" id="svg2" version="1.1" viewBox="0 0 32 32"
                    width="16px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                    xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/"
                    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                    xmlns:svg="http://www.w3.org/2000/svg">
                    <g id="background">
                        <rect fill="none" height="16" width="16" />
                    </g>
                    <g id="arrow_x5F_down">
                        <polygon points="2.002,10 16.001,24 30.002,10  " />
                    </g>
                </svg>
            </div>
            <div *ngIf="isShowSchedule" (click)="isShowSchedule=!isShowSchedule">
                <svg enable-background="new 0 0 32 32" width="16px" height="16px" id="svg2" version="1.1"
                    viewBox="0 0 32 32" width="16px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                    xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/"
                    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                    xmlns:svg="http://www.w3.org/2000/svg">
                    <g id="backbord">
                        <rect fill="none" height="16" width="16" />
                    </g>
                    <g id="arrow_x5F_up">
                        <polygon points="30,22 16.001,8 2.001,22  " />
                    </g>
                </svg>
            </div>
        </div>
        <ng-container *ngIf="isShowSchedule && schedule">
            <div class="row g-1 mb-1">
                <div class="col-sm-5">
                    <div class="row g-1">
                        <div class="col-4">
                            <label for="locCode" class="form-label">Loc</label>
                            <input type="text" class="form-control form-control-sm" id="locCode" disabled
                                [(ngModel)]="schedule.locCode" [ngModelOptions]="{standalone: true}" />
                        </div>
                        <div class="col-4">
                            <label for="startDate" class="form-label">Start Date</label>
                            <input type="text" class="form-control form-control-sm" id="startDate" disabled
                                value="{{schedule.beginDate }}" />
                        </div>
                        <div class="col-4">
                            <label for="endDate" class="form-label">End Date</label>
                            <input type="text" class="form-control form-control-sm" id="endDate" disabled
                                value="{{schedule.endDate }}" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-5">
                    <div class="row g-1">
                        <div class="col-4">
                            <label for="commodity" class="form-label">Commodity</label>
                            <input type="text" class="form-control form-control-sm" id="commodity" disabled
                                value="{{schedule.commodityCode}}" />
                        </div>
                        <div class="col-4">
                            <label for="scheduleLoads" class="form-label">Loads</label>
                            <input type="text" class="form-control form-control-sm" id="scheduleLoads" disabled
                                value="{{schedule.loads}}" />
                        </div>
                        <div class="col-4">
                            <label for="scheduleDispatchLoads" class="form-label">Dispatched</label>
                            <input type="text" class="form-control form-control-sm" id="scheduleDispatchLoads" disabled
                                value="{{schedule.dispatchedLoads}}" />
                        </div>

                    </div>
                </div>
            </div>
            <div class="row g-1 mb-1">
                <div class="col-sm-4">
                    <label for="scheduleCustomer" class="form-label">Customer</label>
                    <input type="text" class="form-control form-control-sm" id="scheduleCustomer" disabled
                        value="{{schedule.customer.customerName}}" />
                </div>
                <div class="col-sm-5">
                    <label for="scheduleLocation" class="form-label">{{scheduleLocationType}}</label>
                    <input type="text" class="form-control form-control-sm" id="scheduleLocation" disabled
                        value="{{schedule.location.locationName}}" />
                </div>
            </div>
            <div class="col-sm-3">
                <div class="row g-1">
                    <div class="col-6">
                        <label for="scheduleLocatonCity" class="form-label">City</label>
                        <input type="text" class="form-control form-control-sm" id="scheduleLocatonCity" disabled
                            value="{{schedule.location.city}}" />
                    </div>

                    <div class="col-6">
                        <label for="scheduleEnteredBy" class="form-label">Entered By</label>
                        <input type="text" class="form-control form-control-sm" id="scheduleEnteredBy" disabled
                            value="{{schedule.createdBy}}" />
                    </div>
                </div>
            </div>
        </ng-container>
    </div>


    <div class="m-0 p-0 mt-2 d-flex align-items-center section-title">
        <div>Dispatches: {{this.dispatchesCount}}</div>
        <div class="text-danger ms-2 ">{{message}}</div>
    </div>
    <div class="col-12 col-md-8 mx-auto">
        <div class="col-12 col-md-8 mx-auto">
            <div class="table-container overflow-auto"
                style="margin-top: 10px; max-height: 50vh; margin-left:-2px; display: flex;">
                <div style="height: 100%">
                    <div class="sticky-header">
                        <div class="d-flex align-items-center">
                            <div class="p-1 text-center col-form-label-sm sticky-column"
                                [ngStyle]="{'margin-left': hasOpenedIcon ? '20px' : '-2px'}"
                                style="font-weight: 600; color: #fff; height: 20px;">
                                {{hasOpenedIcon ?'DetailedActionToOpenContr' : ''}}
                            </div>
                            <div class="p-1 text-center col-form-label-sm dispatch-origin-header"
                                style="min-width: 210px;">
                                Origin</div>
                            <div class="p-1 text-center col-form-label-sm" style="min-width: 140px;">Trucker</div>
                            <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Comm</div>
                            <div class="p-1 text-center col-form-label-sm" style="min-width: 230px;">Destination</div>
                            <div class="p-1 text-center col-form-label-sm" style="min-width: 75px;">Loads</div>
                            <div class="p-1 text-center col-form-label-sm" style="min-width: 100px;">Rate</div>
                            <div class="p-1 text-center col-form-label-sm" style="min-width: 130px;">Email Status</div>
                            <div class="p-1 text-center col-form-label-sm" style="min-width: 130px;">Roger Status</div>
                            <div class="p-1 text-center col-form-label-sm" style="min-width: 150px;">Entered By</div>
                        </div>
                    </div>

                    <div class="row" id="SchedulesSection" style="max-height: 100%">
                        <div class="col-12 col-md-8 mx-auto">
                            <ng-container *ngIf="dispatchList && dispatchList.length > 0; else other_content">
                                <ng-container *ngFor="let data of dispatchList; let i = index">
                                    <mat-card class="card odd-bg" [ngClass]="{'italic': data.showMoreIcons}">
                                        <div class="d-flex align-items-center position-relative">

                                            <div class="p-1 text-center d-flex fixed-icons-container sticky-column"
                                                style="min-width: 10px;">
                                                <div class="text-primary mb-1" role="button" aria-label="Right Arrow"
                                                    (click)="toggleIcons(data)">
                                                    <i class="fa-solid fa-circle-chevron-right"
                                                        style="color: #5194c8; margin-top: 10px;"></i>
                                                </div>

                                                <div [ngClass]="{'disabled': !data.showMoreIcons && !isInitialLoad, 'enable': isShowMoreIconsEnabledInAnyDispatch()}"
                                                    *ngIf="hasOpenedIcon" class="d-flex align-items-center fixed-icons">
                                                    <div class="text-primary ms-2" role="button"
                                                        aria-label="Edit Dispatch">
                                                        <a href="#" class="edit-btn" data-bs-toggle="modal"
                                                            attr.data-bs-target="#{{dispatchFormId}}"
                                                            (click)="editDispatch(data.scheduleId, data.dispatchId)">
                                                            <i class="fa-solid fa-pen-to-square fa-lg"></i>
                                                        </a>
                                                    </div>
                                                    <div class="text-primary mx-2" role="button"
                                                        aria-label="Alert Trucker">
                                                        <a href="#" class="grid-icon-btn send-btn dropdown-item"
                                                            data-bs-toggle="modal"
                                                            attr.data-bs-target="#{{alertTruckerFilterModalIdSc}}"
                                                            (click)="sendAlertTruckerDispatch(data)">
                                                            <i class="fa-solid fa-bell fa-lg"></i>
                                                        </a>
                                                    </div>
                                                    <div class="text-primary mx-2" role="button"
                                                        [ngClass]="{'disabled': !(data.truckerId > 0), 'enable': data.truckerId > 0}"
                                                        aria-label="Send Dispatch">
                                                        <a href="#" class="grid-icon-btn send-btn dropdown-item"
                                                            data-bs-toggle="modal"
                                                            attr.data-bs-target="#{{confirmDispatchFormId}}"
                                                            (click)="sendDispatch(data.dispatchId)">
                                                            <i class="fa-solid fa-envelope fa-lg"></i>
                                                        </a>
                                                    </div>

                                                    <div class="text-primary " role="button"
                                                        aria-label="Apply Loadnumber">
                                                        <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal"
                                                            attr.data-bs-target="#{{loadBankApplyFormId}}"
                                                            title="find load number" (click)="openLoadBank(0,data)">
                                                            <i class="fa-solid fa-upload fa-lg text-primary mx-1"></i>
                                                        </a>
                                                    </div>
                                                    <div class="text-primary " role="button"
                                                        aria-label="Apply Unloadnumber">
                                                        <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal"
                                                            attr.data-bs-target="#{{loadBankApplyFormId}}"
                                                            title="find unload number" (click)="openLoadBank(1,data)">
                                                            <i class="fa-solid fa-download fa-lg text-primary mx-1"></i>
                                                        </a>
                                                    </div>
                                                    <div class="text-primary mx-2" role="button" aria-label="Delete">
                                                        <a href="#" class="grid-icon-btn delete-btn dropdown-item"
                                                            data-bs-toggle="modal"
                                                            attr.data-bs-target="#{{deleteFormId}}"
                                                            (click)="deleteDispatch(data.dispatchId,data.truckerName)">
                                                            <i class="fa-solid fa-trash fa-lg"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="scrollable-content"
                                                [ngClass]="{'disabled': !data.showMoreIcons && !isInitialLoad, 'enable': isShowMoreIconsEnabledInAnyDispatch()}">
                                                <div class="p-1 text-center"
                                                    style="min-width: 210px; max-width: 210px; white-space: normal; overflow-wrap: break-word;">
                                                    <div>{{data.originName}}, </div>
                                                    <div>{{data.originCity}}</div>
                                                </div>
                                                <div class="p-1 text-center"
                                                    style="min-width: 140px; max-width: 140px; white-space: normal; overflow-wrap: break-word;"
                                                    [ngClass]="{'text-danger': data.roundId > 0 }">
                                                    {{data.truckerName}}
                                                </div>
                                                <div class="p-1 text-center" style="min-width: 75px;">{{
                                                    data.commodityCode
                                                    }}</div>
                                                <div class="p-1 text-center"
                                                    style="min-width: 230px; max-width: 230px; white-space: normal; overflow-wrap: break-word;">
                                                    <div>{{data.destinationName}},</div>
                                                    <div>{{data.destinationCity}}</div>
                                                </div>
                                                <div class="p-1 text-center" style="min-width: 75px;">
                                                    <button #loadsModalBtn type="button" class="link-style"
                                                        data-bs-toggle="modal" data-bs-target="#loadsModal"
                                                        [ngClass]="{'disable-load-count': data.showMoreIcons }"
                                                        [disabled]="!isShowMoreIconsEnabledInAnyDispatch()"
                                                        (click)="setSelectedLoadItem(globalDispatchId ?? data.dispatchId)">
                                                        {{ data.numberOfLoads }}
                                                    </button>
                                                </div>
                                                <div class="p-1 text-center" style="min-width: 100px;">
                                                    {{data.rate}}
                                                </div>
                                                <div class="p-1 text-center" style="min-width: 130px;">
                                                    {{data.emailStatus}}</div>
                                                <div class="p-1 text-center" style="min-width: 130px;">
                                                    {{data.rogerStatus}}</div>
                                                <div class="p-1 text-center" style="min-width: 150px;">
                                                    {{data.enteredBy}}</div>
                                            </div>
                                        </div>
                                    </mat-card>
                                </ng-container>
                            </ng-container>
                        </div>

                        <ng-template #other_content>
                            <div class="col-md-12 d-flex align-items-center" style="height: 100%;">
                                <mat-card class="card" style="width: 100%; max-width: 600px;">
                                    <mat-card-content>No dispatches found for your search criteria</mat-card-content>
                                </mat-card>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-load-list (loadListEmit)="loadLoads($event)" (closePoupEmit)="globalDispatchId = null;"
        (deleteComplete)="reloadDispatchCount($event)" [loads]="loadsData"></app-load-list>

    <div class="fixedButtonRight" data-bs-toggle="modal" data-bs-target="#dispatchModal"
        (click)="manualScheduleClick()">
        <div class="roundedFixedRightBtn"><i class="fa-solid fa-circle-plus"></i></div>
    </div>

    <dispatch-form [dispatchParameters]="dispatchForm" (saveComplete)="dispatchSaveComplete($event)"></dispatch-form>


    <load-bank-apply [parameters]="loadBankApplyParametersVd" [isMobile]="true"
        (loadBankApplyCompleteForDispatchMobile)="loadBankApplyComplete($event)"
        [loadBankApplyFormId]="loadBankApplyFormId"></load-bank-apply>


    <delete-confirm #deleteConfirmChildComponent [deleteItemParameters]="deleteItemParams" [deleteFormId]="deleteFormId"
        (confirmEmitter)="deleteItem($event, deleteItemParams)"></delete-confirm>

    <confirm-dispatch [dispatchId]="sendDispatchId" [refresh]="true" [confirmDispatchFormId]="confirmDispatchFormId"
        (sendComplete)="sendComplete($event)"></confirm-dispatch>

    <app-alert-truckers-filter [alertParameters]="alertTruckerForm"
        [dispatchId]="sendAlertTruckerDispatchId"></app-alert-truckers-filter>

    <!-- <app-footer-mobile></app-footer-mobile> -->